// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body,
html,
md-content,
.back-white {
  background-color: #fff;
}

.offering md-content {
  overflow: inherit;
}

.detail-col-left {
  padding-left: 22px;
}
.detail-col-right {
  margin-top: 35px;
}

.col1 .expand-it,
.col1 .collapse-it {
  display: inline-block;
  font-size: 22px;
  font-weight: bold;
  outline: none;
  padding-top: 17px;
  vertical-align: top;
  width: 24px;
}

.expanded-student-detail {
  font-size: 13px;
  padding-left: 28px;
}
.expanded-student-detail p {
  margin-bottom: 2px;
}
.expanded-student-detail p span {
  font-weight: 600;
}

.group-status {
  background-color: #f0f0f0;
  padding: 15px 0px;
}

.group-status h3 {
  font-weight: 600;
  margin-bottom: 3px;
  padding-left: 8px;
}

.group-status .grade-range-error {
  white-space: nowrap;
  font-weight: bold !important;
}

.instructor-nav-secondary {
  background-color: #e0e0e0;
  height: 40px;
  line-height: 40px;
  padding-left: 24px;
}
.instructor-nav-secondary a {
  font-size: 12px;
}
.instructor-nav-secondary a.selected {
  font-weight: 700;
}
.instructor-extra-nav {
  font-size: 16px;
  padding-top: 51px;
  padding-right: 0;
  text-align: right;
}

.landing-button-container {
  padding-top: 12px;
  padding-left: 7px;
}
.landing-button-container button:not(:last-child) {
  margin-right: 5px;
}

.left0 {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.offerings .actions {
  background-color: #f0f0f0;
  padding: 15px;
}

.offerings .actions h3,
.offerings .actions ul {
  float: left;
  margin: 0px;
  padding: 0px;
}

.offerings .actions ul {
  float: right;
  list-style: none;
}

.offerings .actions ul li {
}

.offering-detail-category {
  display: inline-block;
  font-size: 13px;
  vertical-align: top;
  width: 115px;
}
.offering-detail-category-right {
  display: inline-block;
  font-size: 13px;
  vertical-align: top;
  width: 160px;
}

.offering-detail-value {
  font-size: 13px;
}

p.offering-detail-value {
  margin-bottom: 0;
}

.offering-detail-row {
  margin-bottom: 12px;
}
.offering-detail-row-right {
  margin: 0px;
}

.offering-detail-container {
  display: inline-block;
}

.offering-overwrite {
  background: #f0f0f0;
  padding-bottom: 0;
}

.offerings-button {
  font-size: 16px;
  text-transform: capitalize;
}

.padbot20 {
  padding-bottom: 20px;
}
.padtop24 {
  padding-top: 24px;
}

p.registration-date {
  font-size: 13px;
  margin-top: 0;
}
p.registration-date span {
  font-size: 13px;
  font-weight: 600;
}

.result-container.add-replace {
  height: 478px;
  margin-top: 26px;
  margin-right: 33px;
  overflow-y: scroll;
}
.results-title.add-replace .add-replace-org-bar {
  background-color: #e5e5e5;
  font-size: 14px;
  font-weight: 600;
  height: 44px;
  line-height: 44px;
  margin-bottom: 8px;
  padding-left: 27px;
  text-transform: uppercase;
  width: 591px;
}
.add-replace-org-bar input[type='checkbox'],
.add-replace-group-bar input[type='checkbox'] {
  position: relative;
  top: 2px;
  margin-right: 10px !important;
  margin-left: 14px !important;
}
.result-instance.add-replace .add-replace-group-bar {
  background-color: #f3f1f2;
  font-size: 14px;
  font-weight: 600;
  line-height: 44px;
  margin: 0 0 8px 36px;
  padding-left: 64px;
  text-transform: uppercase;
  width: 555px;
}
.result-instance.add-replace .add-replace-group-bar:last-child {
  margin-bottom: 10px;
}
.results-title.add-replace {
  background: #fff;
  margin: 44px 0 0 15px;
  padding: 25px 8px 8px 24px;
}
.results-title.add-replace h3 {
  font-size: 20px;
  font-weight: 600;
}
.results-title.add-replace h3 span {
  font-style: italic;
  font-weight: 400;
}
.add-replace-name-bar {
  padding-left: 24px;
}
.add-replace-name-bar div {
  font-size: 10px;
  font-weight: 400;
  line-height: 24px;
  text-transform: capitalize;
}
.add-replace-name-bar div:last-child {
  padding-bottom: 12px;
}

.roster-action {
  display: inline;
}

.roster-action + .roster-action:before {
  content: '|';
  color: black;
  padding-right: 6px;
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.disable-studentCta {
  pointer-events: none !important;
}

.enable-studentCta {
  pointer-events: auto !important;
}

.group-status-detail,
.select-session-detail {
  padding-bottom: 15px;
  background-color: #fff;
}

.group-status-detail:not(:last-child),
.select-session-detail:not(:last-child) {
  border-bottom: solid 1px #e5e5e5;
}
.waitlist-row {
  border-top: solid 1px #e5e5e5;
}

.group-status-detail h3,
.waitlist-row h3 {
  display: inline-block;
  font-weight: 600;
  margin-bottom: 3px;
}

.waitlist-count {
  font-size: 15px;
  font-weight: 600;
  padding-right: 0;
  padding-bottom: 10px;
  text-align: right;
}

.group-status-detail h3 span,
.select-session-detail h3 span {
  font-size: 13px;
  font-style: italic;
  font-weight: 400;
  text-transform: capitalize;
}

.roster-student-col1 {
  padding-top: 10px;
}
.group-status-detail .expand-it,
.waitlist-row .expand-it {
  display: inline-block;
}

.select-session {
  background-color: #f0f0f0;
  padding-top: 25px;
}
.select-session h3 {
  font-weight: 600;
  margin-bottom: 3px;
  padding-left: 24px;
}
.select-session-detail h3 {
  display: inline-block;
  font-weight: 600;
  margin-bottom: 3px;
}

.session-col-left {
  padding-left: 10px;
}
.session-color {
  background-color: #f0f0f0;
}

#remove-confirmation {
  color: red;
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  padding-top: 3px;
}

/*** column 1 screens */

.group-status .col1 {
  padding-top: 2px;
}
.select-session .col1 {
  padding-top: 5px;
  padding-left: 0;
}

.row .group-status-detail .col1,
.row .select-session-detail .col1,
.row .waitlist-row .col1 {
  padding-left: 0 !important;
  padding-right: 0;
  padding-top: 11px;
}

.row .group-status .col1 {
  padding-left: 28px !important;
}
.row .group-status-detail .col1,
.row .waitlist-row .col1 {
  padding-left: 15px !important;
}

.group-status-detail .col1 > p,
.waitlist-row .col1 > p,
.select-session-detail .col1 > p {
  padding-left: 28px;
}

.group-status-detail .col1 p span,
.select-session-detail .col1 p span,
.waitlist-row .col1 p span {
  font-weight: 600;
}

/*** column 2 screens ***/

.select-session .col2 {
  padding-top: 8px;
}

.group-status .col2 span {
  display: inline-block;
  font-size: 11px;
  padding-bottom: 8px;
}
.group-status-detail .col2 span {
  display: inline-block;
  font-size: 11px;
  padding-top: 28px;
  padding-bottom: 8px;
}

.group-status .col2 select {
  border: solid 1px #999;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 25px;
  margin-bottom: 40px;
  margin-top: 0;
  padding: 0 4px;
  width: 237px;
  -webkit-appearance: menulist;
}
.group-status-detail .col2 select {
  border: solid 1px #999;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 25px;
  margin-bottom: 40px;
  padding: 0 4px;
  -webkit-appearance: menulist;
}

.select-session .col2 select {
  border: solid 1px #999;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 25px;
  margin-top: 18px;
  margin-bottom: 40px;
  padding: 0 4px;
  width: 307px;
  -webkit-appearance: menulist;
}

/*** column 3 ***/

.group-status .col3,
.group-status-detail .col3 {
  padding-left: 5px;
}
.select-session .col3,
.select-session-detail .col3 {
  padding-left: 71px;
  padding-top: 4px;
}

.group-status .col3 span {
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  padding-bottom: 8px;
  padding-top: 2px;
}
.group-status-detail .col3 span {
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  padding-bottom: 8px;
  padding-top: 28px;
}
.select-session .col3 span,
.select-session-detail .col3 span {
  display: inline-block;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 4px;
}
.select-session .col3 span {
  padding-bottom: 2px;
}
.select-session-detail .col3 span {
  padding-top: 24px;
}

.group-status .col3 input,
.group-status-detail .col3 input,
.select-session .col3 input,
.select-session-detail .col3 input {
  border: solid 1px #999;
  box-sizing: border-box;
  display: inline-block;
  font-size: 16px;
  height: 25px;
  padding: 4px;
  width: 108px;
}

/*** column 4 ***/

.group-status .col4 {
  padding-top: 17px;
}
.group-status-detail .col4 {
  padding-top: 44px;
  text-align: center;
}
.select-session .col4 {
  padding-top: 18px;
}
.select-session-detail .col4 {
  padding-top: 37px;
}

.group-status .col4 {
  text-align: center;
}
.group-status .col4 button,
.group-status-detail .col4 button,
.select-session .col4 button,
.select-session-detail .col4 button {
  display: inline-block;
  margin: 0 auto !important;
  width: 142px;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden; /* fixes a bug specific to Chrome, where a hover event causes the hovered element to slide horizontally */
}
.group-status .col4 button,
.select-session .col4 button {
  padding-left: 42px;
}

.waitlist-row .col4 {
  padding-top: 29px;
  color: red;
  font-size: 13px;
  text-align: right;
}
.waitlist-row .col4 span {
  display: none;
  font-weight: 600;
}

.waitlist-row .col4 select {
  border: solid 1px #999;
  box-sizing: border-box;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  height: 25px;
  margin-bottom: 40px;
  padding: 0 4px;
  width: 237px;
  -webkit-appearance: menulist;
}

/*** column 5 ***/

.group-status .col5,
.select-session .col5 {
  padding-top: 27px;
}
.group-status-detail .col5 {
  padding-top: 54px;
}
.select-session-detail .col5 {
  padding-top: 47px;
}
.waitlist-row .col5 {
  padding-top: 33px;
  padding-right: 0px;
}

.group-status .col5 a,
.group-status-detail .col5 a,
.select-session .col5 a,
.select-session-detail .col5 a {
  font-size: 13px !important;
  font-weight: 400;
}
.group-status-detail .col5 span {
  padding: 0 10px;
}

.group-status-detail .student-grade-error {
  white-space: nowrap;
  padding-top: 5px !important;
  margin-top: 15px;
  font-weight: bold !important;
}

/*** end column classes ***/

footer.container {
  padding-bottom: 30px;
}

.col5 ul {
  padding: 0px;
}

.col5 ul li {
  display: inline;
  float: left;
}

.offeringModal .buttons .spinner,
.offeringModal .buttons .spinner {
  float: right;
  margin: 0 65px;
}

.roster .col-md-2 .spinner {
  margin: 0 auto;
}

.col5 .spinner {
  margin: 0 auto;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/offerings/view.css"],"names":[],"mappings":"AAAA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;AACA;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;AAClC;AACA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,uBAAuB;;AAEvB;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;AACA;;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA,yBAAyB;;AAEzB;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,iBAAiB;;AAEjB;;EAEE,iBAAiB;AACnB;AACA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA,iBAAiB;;AAEjB;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;AACA;;;;EAIE,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,mCAAmC;EACnC,2BAA2B,EAAE,yGAAyG;AACxI;AACA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,4BAA4B;AAC9B;;AAEA,iBAAiB;;AAEjB;;EAEE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA,2BAA2B;;AAE3B;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["body,\nhtml,\nmd-content,\n.back-white {\n  background-color: #fff;\n}\n\n.offering md-content {\n  overflow: inherit;\n}\n\n.detail-col-left {\n  padding-left: 22px;\n}\n.detail-col-right {\n  margin-top: 35px;\n}\n\n.col1 .expand-it,\n.col1 .collapse-it {\n  display: inline-block;\n  font-size: 22px;\n  font-weight: bold;\n  outline: none;\n  padding-top: 17px;\n  vertical-align: top;\n  width: 24px;\n}\n\n.expanded-student-detail {\n  font-size: 13px;\n  padding-left: 28px;\n}\n.expanded-student-detail p {\n  margin-bottom: 2px;\n}\n.expanded-student-detail p span {\n  font-weight: 600;\n}\n\n.group-status {\n  background-color: #f0f0f0;\n  padding: 15px 0px;\n}\n\n.group-status h3 {\n  font-weight: 600;\n  margin-bottom: 3px;\n  padding-left: 8px;\n}\n\n.group-status .grade-range-error {\n  white-space: nowrap;\n  font-weight: bold !important;\n}\n\n.instructor-nav-secondary {\n  background-color: #e0e0e0;\n  height: 40px;\n  line-height: 40px;\n  padding-left: 24px;\n}\n.instructor-nav-secondary a {\n  font-size: 12px;\n}\n.instructor-nav-secondary a.selected {\n  font-weight: 700;\n}\n.instructor-extra-nav {\n  font-size: 16px;\n  padding-top: 51px;\n  padding-right: 0;\n  text-align: right;\n}\n\n.landing-button-container {\n  padding-top: 12px;\n  padding-left: 7px;\n}\n.landing-button-container button:not(:last-child) {\n  margin-right: 5px;\n}\n\n.left0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.offerings .actions {\n  background-color: #f0f0f0;\n  padding: 15px;\n}\n\n.offerings .actions h3,\n.offerings .actions ul {\n  float: left;\n  margin: 0px;\n  padding: 0px;\n}\n\n.offerings .actions ul {\n  float: right;\n  list-style: none;\n}\n\n.offerings .actions ul li {\n}\n\n.offering-detail-category {\n  display: inline-block;\n  font-size: 13px;\n  vertical-align: top;\n  width: 115px;\n}\n.offering-detail-category-right {\n  display: inline-block;\n  font-size: 13px;\n  vertical-align: top;\n  width: 160px;\n}\n\n.offering-detail-value {\n  font-size: 13px;\n}\n\np.offering-detail-value {\n  margin-bottom: 0;\n}\n\n.offering-detail-row {\n  margin-bottom: 12px;\n}\n.offering-detail-row-right {\n  margin: 0px;\n}\n\n.offering-detail-container {\n  display: inline-block;\n}\n\n.offering-overwrite {\n  background: #f0f0f0;\n  padding-bottom: 0;\n}\n\n.offerings-button {\n  font-size: 16px;\n  text-transform: capitalize;\n}\n\n.padbot20 {\n  padding-bottom: 20px;\n}\n.padtop24 {\n  padding-top: 24px;\n}\n\np.registration-date {\n  font-size: 13px;\n  margin-top: 0;\n}\np.registration-date span {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.result-container.add-replace {\n  height: 478px;\n  margin-top: 26px;\n  margin-right: 33px;\n  overflow-y: scroll;\n}\n.results-title.add-replace .add-replace-org-bar {\n  background-color: #e5e5e5;\n  font-size: 14px;\n  font-weight: 600;\n  height: 44px;\n  line-height: 44px;\n  margin-bottom: 8px;\n  padding-left: 27px;\n  text-transform: uppercase;\n  width: 591px;\n}\n.add-replace-org-bar input[type='checkbox'],\n.add-replace-group-bar input[type='checkbox'] {\n  position: relative;\n  top: 2px;\n  margin-right: 10px !important;\n  margin-left: 14px !important;\n}\n.result-instance.add-replace .add-replace-group-bar {\n  background-color: #f3f1f2;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 44px;\n  margin: 0 0 8px 36px;\n  padding-left: 64px;\n  text-transform: uppercase;\n  width: 555px;\n}\n.result-instance.add-replace .add-replace-group-bar:last-child {\n  margin-bottom: 10px;\n}\n.results-title.add-replace {\n  background: #fff;\n  margin: 44px 0 0 15px;\n  padding: 25px 8px 8px 24px;\n}\n.results-title.add-replace h3 {\n  font-size: 20px;\n  font-weight: 600;\n}\n.results-title.add-replace h3 span {\n  font-style: italic;\n  font-weight: 400;\n}\n.add-replace-name-bar {\n  padding-left: 24px;\n}\n.add-replace-name-bar div {\n  font-size: 10px;\n  font-weight: 400;\n  line-height: 24px;\n  text-transform: capitalize;\n}\n.add-replace-name-bar div:last-child {\n  padding-bottom: 12px;\n}\n\n.roster-action {\n  display: inline;\n}\n\n.roster-action + .roster-action:before {\n  content: '|';\n  color: black;\n  padding-right: 6px;\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.disable-studentCta {\n  pointer-events: none !important;\n}\n\n.enable-studentCta {\n  pointer-events: auto !important;\n}\n\n.group-status-detail,\n.select-session-detail {\n  padding-bottom: 15px;\n  background-color: #fff;\n}\n\n.group-status-detail:not(:last-child),\n.select-session-detail:not(:last-child) {\n  border-bottom: solid 1px #e5e5e5;\n}\n.waitlist-row {\n  border-top: solid 1px #e5e5e5;\n}\n\n.group-status-detail h3,\n.waitlist-row h3 {\n  display: inline-block;\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n\n.waitlist-count {\n  font-size: 15px;\n  font-weight: 600;\n  padding-right: 0;\n  padding-bottom: 10px;\n  text-align: right;\n}\n\n.group-status-detail h3 span,\n.select-session-detail h3 span {\n  font-size: 13px;\n  font-style: italic;\n  font-weight: 400;\n  text-transform: capitalize;\n}\n\n.roster-student-col1 {\n  padding-top: 10px;\n}\n.group-status-detail .expand-it,\n.waitlist-row .expand-it {\n  display: inline-block;\n}\n\n.select-session {\n  background-color: #f0f0f0;\n  padding-top: 25px;\n}\n.select-session h3 {\n  font-weight: 600;\n  margin-bottom: 3px;\n  padding-left: 24px;\n}\n.select-session-detail h3 {\n  display: inline-block;\n  font-weight: 600;\n  margin-bottom: 3px;\n}\n\n.session-col-left {\n  padding-left: 10px;\n}\n.session-color {\n  background-color: #f0f0f0;\n}\n\n#remove-confirmation {\n  color: red;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 600;\n  padding-top: 3px;\n}\n\n/*** column 1 screens */\n\n.group-status .col1 {\n  padding-top: 2px;\n}\n.select-session .col1 {\n  padding-top: 5px;\n  padding-left: 0;\n}\n\n.row .group-status-detail .col1,\n.row .select-session-detail .col1,\n.row .waitlist-row .col1 {\n  padding-left: 0 !important;\n  padding-right: 0;\n  padding-top: 11px;\n}\n\n.row .group-status .col1 {\n  padding-left: 28px !important;\n}\n.row .group-status-detail .col1,\n.row .waitlist-row .col1 {\n  padding-left: 15px !important;\n}\n\n.group-status-detail .col1 > p,\n.waitlist-row .col1 > p,\n.select-session-detail .col1 > p {\n  padding-left: 28px;\n}\n\n.group-status-detail .col1 p span,\n.select-session-detail .col1 p span,\n.waitlist-row .col1 p span {\n  font-weight: 600;\n}\n\n/*** column 2 screens ***/\n\n.select-session .col2 {\n  padding-top: 8px;\n}\n\n.group-status .col2 span {\n  display: inline-block;\n  font-size: 11px;\n  padding-bottom: 8px;\n}\n.group-status-detail .col2 span {\n  display: inline-block;\n  font-size: 11px;\n  padding-top: 28px;\n  padding-bottom: 8px;\n}\n\n.group-status .col2 select {\n  border: solid 1px #999;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  height: 25px;\n  margin-bottom: 40px;\n  margin-top: 0;\n  padding: 0 4px;\n  width: 237px;\n  -webkit-appearance: menulist;\n}\n.group-status-detail .col2 select {\n  border: solid 1px #999;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  height: 25px;\n  margin-bottom: 40px;\n  padding: 0 4px;\n  -webkit-appearance: menulist;\n}\n\n.select-session .col2 select {\n  border: solid 1px #999;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  height: 25px;\n  margin-top: 18px;\n  margin-bottom: 40px;\n  padding: 0 4px;\n  width: 307px;\n  -webkit-appearance: menulist;\n}\n\n/*** column 3 ***/\n\n.group-status .col3,\n.group-status-detail .col3 {\n  padding-left: 5px;\n}\n.select-session .col3,\n.select-session-detail .col3 {\n  padding-left: 71px;\n  padding-top: 4px;\n}\n\n.group-status .col3 span {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 400;\n  padding-bottom: 8px;\n  padding-top: 2px;\n}\n.group-status-detail .col3 span {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 400;\n  padding-bottom: 8px;\n  padding-top: 28px;\n}\n.select-session .col3 span,\n.select-session-detail .col3 span {\n  display: inline-block;\n  font-size: 11px;\n  font-weight: 400;\n  margin-bottom: 4px;\n}\n.select-session .col3 span {\n  padding-bottom: 2px;\n}\n.select-session-detail .col3 span {\n  padding-top: 24px;\n}\n\n.group-status .col3 input,\n.group-status-detail .col3 input,\n.select-session .col3 input,\n.select-session-detail .col3 input {\n  border: solid 1px #999;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 16px;\n  height: 25px;\n  padding: 4px;\n  width: 108px;\n}\n\n/*** column 4 ***/\n\n.group-status .col4 {\n  padding-top: 17px;\n}\n.group-status-detail .col4 {\n  padding-top: 44px;\n  text-align: center;\n}\n.select-session .col4 {\n  padding-top: 18px;\n}\n.select-session-detail .col4 {\n  padding-top: 37px;\n}\n\n.group-status .col4 {\n  text-align: center;\n}\n.group-status .col4 button,\n.group-status-detail .col4 button,\n.select-session .col4 button,\n.select-session-detail .col4 button {\n  display: inline-block;\n  margin: 0 auto !important;\n  width: 142px;\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden; /* fixes a bug specific to Chrome, where a hover event causes the hovered element to slide horizontally */\n}\n.group-status .col4 button,\n.select-session .col4 button {\n  padding-left: 42px;\n}\n\n.waitlist-row .col4 {\n  padding-top: 29px;\n  color: red;\n  font-size: 13px;\n  text-align: right;\n}\n.waitlist-row .col4 span {\n  display: none;\n  font-weight: 600;\n}\n\n.waitlist-row .col4 select {\n  border: solid 1px #999;\n  box-sizing: border-box;\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 400;\n  height: 25px;\n  margin-bottom: 40px;\n  padding: 0 4px;\n  width: 237px;\n  -webkit-appearance: menulist;\n}\n\n/*** column 5 ***/\n\n.group-status .col5,\n.select-session .col5 {\n  padding-top: 27px;\n}\n.group-status-detail .col5 {\n  padding-top: 54px;\n}\n.select-session-detail .col5 {\n  padding-top: 47px;\n}\n.waitlist-row .col5 {\n  padding-top: 33px;\n  padding-right: 0px;\n}\n\n.group-status .col5 a,\n.group-status-detail .col5 a,\n.select-session .col5 a,\n.select-session-detail .col5 a {\n  font-size: 13px !important;\n  font-weight: 400;\n}\n.group-status-detail .col5 span {\n  padding: 0 10px;\n}\n\n.group-status-detail .student-grade-error {\n  white-space: nowrap;\n  padding-top: 5px !important;\n  margin-top: 15px;\n  font-weight: bold !important;\n}\n\n/*** end column classes ***/\n\nfooter.container {\n  padding-bottom: 30px;\n}\n\n.col5 ul {\n  padding: 0px;\n}\n\n.col5 ul li {\n  display: inline;\n  float: left;\n}\n\n.offeringModal .buttons .spinner,\n.offeringModal .buttons .spinner {\n  float: right;\n  margin: 0 65px;\n}\n\n.roster .col-md-2 .spinner {\n  margin: 0 auto;\n}\n\n.col5 .spinner {\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
